import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { translate } from 'react-i18next';

import HighchartsArea, { defaultOptions } from '../graph/HighchartsArea';
import HeaderComponent from '../HeaderComponent';
import LoadingComponent from '../LoadingComponent';
import Modal from '../Modal';

import { padDecimals } from '../../service/market';

import css from '../../styles/instrument/dividends';

moment.locale('sv');

class Dividends extends Component {
    static propTypes = {
        symbol: PropTypes.string,
        title: PropTypes.string,
        dividends: PropTypes.array,
        isLoading: PropTypes.bool,
        modalOpen: PropTypes.bool,
        openModal: PropTypes.func,
        closeModal: PropTypes.func,
        t: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.state = { data: [] };

        this._setData = dividends => {
            if (!dividends.length) return;

            const data = [];

            const divs = dividends.slice().reverse();

            for (const i in divs) {
                if (divs.hasOwnProperty(i)) {
                    const { DIVIDEND_RATE, DIVIDEND_EX_DATE, DIVIDEND_CURRENCY } = divs[i];

                    const date = moment(DIVIDEND_EX_DATE).format('X');

                    data.push({
                        x: parseInt(date, 10) * 1000,
                        y: DIVIDEND_RATE,
                        currency: DIVIDEND_CURRENCY,
                    });
                }
            }

            this.setState({ data });
        };
    }

    componentDidMount() {
        this._setData(this.props.dividends);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.symbol !== nextProps.symbol) {
            this._setData(nextProps.dividends);
        }
    }

    renderChart() {
        if (!this.state.data.length || this.state.data.length < 2) return null;

        const config = Object.assign({}, defaultOptions, { series: [{ data: this.state.data }] });

        return (
            <div className={css.graphWrapper}>
                <HighchartsArea
                    className={css.graph}
                    config={config}
                    data={this.state.data}
                />
            </div>
        );
    }

    renderModal() {
        if (!this.props.modalOpen) return null;

        const { t } = this.props;

        return (
            <Modal
                title={t('dividends.title')}
                symbol={this.props.title}
                onClick={this.props.closeModal}
            >
                <div className={css.modalWrapper}>
                    {this.renderChart()}
                    <table className={css.table}>
                        <thead className={css.thead}>
                            <tr>
                                <th>{t('dividends.date')}</th>
                                <th className={css.alignRight}>{t('dividends.rate')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderDividends()}
                        </tbody>
                    </table>
                </div>
            </Modal>
        );
    }

    renderDividends(limit) {
        const { dividends } = this.props;

        const rows = [];

        let count = 0;

        for (const i in dividends) {
            if (dividends.hasOwnProperty(i) && (!limit || count < limit)) {
                const { DIVIDEND_RATE, DIVIDEND_CURRENCY, DIVIDEND_EX_DATE } = dividends[i];

                count++;

                const format = moment(DIVIDEND_EX_DATE)
                    .isSame(moment().startOf('year'), 'y') ? 'D. MMMM' : 'DD.MM.YYYY';

                rows.push(
                    <tr className={css.tableRow} key={DIVIDEND_EX_DATE}>
                        <td>{moment(DIVIDEND_EX_DATE).format(format)}</td>
                        <td className={css.alignRight}>
                            {padDecimals(DIVIDEND_RATE)} {DIVIDEND_CURRENCY}
                        </td>
                    </tr>
                );
            }
        }

        return rows;
    }

    renderContent() {
        if (!this.props.dividends.length) {
            return <LoadingComponent height={366} />;
        }

        const { t } = this.props;

        return (
            <div className={css.tableWrapper}>
                {this.renderChart()}
                <table className={css.table}>
                    <thead className={css.thead}>
                        <tr>
                            <th>{t('dividends.date')}</th>
                            <th className={css.alignRight}>{t('dividends.rate')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderDividends(5)}
                    </tbody>
                </table>
                {this.renderModal()}
            </div>
        );
    }

    render() {
        let buttonConfig;

        if (!this.props.dividends.length && !this.props.isLoading) {
            return null;
        }

        const { t } = this.props;

        if (this.props.dividends.length > 5) {
            buttonConfig = {
                label: t('common:seeAll'),
                onclick: () => this.props.openModal('dividends'),
            };
        }

        return (
            <HeaderComponent
                title={t('dividends.title')}
                {...buttonConfig}
            >
                {this.renderContent()}
            </HeaderComponent>
        );
    }
}

export default translate('stocks')(Dividends);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/Dividends.js
 **/